import ApiCaller from "../../Connection/ApiCaller";
const apiEndpoint = "Auth";

export const onLogOut = async () => {
  return await ApiCaller.get(`${apiEndpoint}/LogOut`);
};
